import { motion } from "framer-motion";
import { SUBJECTS } from "./data";
import { SectionHeading } from "./Services";
import { scrollToSection } from "@/lib/scrollTo";

export const Subjects = () => (
  <section id="subjects" className="mx-auto max-w-7xl px-5 py-28 sm:px-8 sm:py-36" data-testid="subjects-section">
    <SectionHeading id="subjects" overline="Fields of Expertise" title="One writer for" accent="every discipline." />
    <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-[#D4AF37]/15 bg-[#D4AF37]/10 sm:grid-cols-3 lg:grid-cols-4">
      {SUBJECTS.map((s, i) => (
        <motion.button
          key={s}
          onClick={() => scrollToSection("#order")}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.5, delay: (i % 8) * 0.05 }}
          className="group flex items-center justify-between gap-3 bg-[#F3EEE2] px-6 py-6 text-left transition-colors duration-300 hover:bg-[#16345F]"
          data-testid={`subject-${s.toLowerCase().replace(/[^a-z]+/g, "-")}`}
        >
          <span className="font-mono-accent text-[11px] uppercase tracking-[0.15em] text-[#46586F] transition-colors duration-300 group-hover:text-[#A07E1F]">
            {s}
          </span>
          <span className="h-1.5 w-1.5 rotate-45 bg-[#D4AF37]/30 transition-colors duration-300 group-hover:bg-[#D4AF37]" />
        </motion.button>
      ))}
    </div>
    <motion.p
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, delay: 0.3 }}
      className="mt-8 text-sm text-[#75849B]"
      data-testid="subjects-note"
    >
      Don't see your subject? We cover 100+ disciplines — ask us on WhatsApp or through the contact form below.
    </motion.p>
  </section>
);
